import React from 'react'

import { AnalyzePage } from '@/containers/Analyze/AnalyzePage'

export const PageAnalyze = () => {
    return <AnalyzePage />
}
